import { isDevelopment } from "../context/ApplicationContextProvider";

export default class Log {

    static verbose(){
        console.log(arguments);
    }

    static private(){
        if(isDevelopment()){
            console.log(arguments);
        }
    }

    static error(){
        console.error(arguments);
    }
}